const WidgetMode = {
  default: {
    name: 'default',
    excludedFields: ['message', 'widgetMode']
  },
  smartModem: {
    name: 'Smart Modem',
    excludedFields: ['message', 'widgetMode', 'WLANLight', 'InternetLight', 'WanLight', 'PowerLight']
  },
  hg659: {
    name: 'Skinny HG659',
    excludedFields: ['message', 'widgetMode', 'SmartModemLight']
  }
};

export default WidgetMode;



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/WidgetMode.js
 **/